<template>
  <v-footer v-bind="$attrs">
    <slot></slot>
  </v-footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
